import { SignalSourceEnum } from "app/pages/sales-intelligence/domain/signals/types/signal";
import isPermanentSignal from "app/pages/sales-intelligence/domain/signals/types/type-guards/isPermanentSignal";
import type salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { SignalsRestApiStatus } from "./types";

type FetchedSignals = Awaited<ReturnType<typeof salesApiService.signals.fetchSignals>>;

export const selectSignalsRestApiStatus = (data: FetchedSignals): SignalsRestApiStatus => {
    const restApiSignals = data.signals.filter(
        (signal) => signal.signalSource === SignalSourceEnum.RestApi && isPermanentSignal(signal),
    );

    return {
        isConfigured: restApiSignals.length > 0,
        signalsCount: restApiSignals.length,
    };
};
